import React from 'react';
import { Stack, Typography } from '@mui/material';

export interface Props {
  Image: React.FC<{width: string, height: string}>,
  imageWidth?: string;
  imageHeight?: string;
  heading?: string,
  description?: string,
}

/**
 * @deprecated this file has been replaced by fallback-image.tsx
 */
export default function Poster({
  ...props
}: Props) {
  const trimmedHeading = props.heading?.trim();
  const trimmedDescription = props.description?.trim();

  return (
    <Stack alignItems="center" justifyContent="center">
      <Stack direction="row" mb={2.5} width={props.imageWidth ?? '100%'} height={props.imageHeight ?? '100%'}>
        <props.Image width="100%" height="100%" />
      </Stack>
      {trimmedHeading && <Typography variant="h3" mb={1}>{trimmedHeading}</Typography>}
      {trimmedDescription && <Typography>{trimmedDescription}</Typography>}
    </Stack>
  );
}
